import React from "react";
import {
  Form,
  Input,
  Button,
  Icon,
  Segment,
  Header,
  Label,
  Message,
  FormField,
} from "semantic-ui-react";
import "./SecurityTab.scss";

export function SecurityTab({
  loading,
  formMessage,
  formik,
  showPasswords,
  togglePasswordVisibility,
}) {
  return (
    <Segment padded className="security-tab">
      <Header as="h3" dividing>
        <Header.Content>Cambiar contraseña</Header.Content>
      </Header>

      <div className="security-tab__password-area">
        {formMessage.show && (
          <Message
            success={formMessage.type === "success"}
            error={formMessage.type === "error"}
            header={formMessage.type === "success" ? "¡Éxito!" : "Error"}
            content={formMessage.content}
          />
        )}

        <Form
          className="security-tab__password-form"
          onSubmit={formik.handleSubmit}
        >
          <FormField>
            <label>Contraseña actual</label>
            <Input
              icon="lock"
              iconPosition="left"
              placeholder="Ingresa tu contraseña actual"
              type={showPasswords.currentPassword ? "text" : "password"}
              name="currentPassword"
              value={formik.values.currentPassword}
              onChange={formik.handleChange}
              error={
                formik.touched.currentPassword && formik.errors.currentPassword
                  ? formik.errors.currentPassword
                  : null
              }
              action={{
                icon: showPasswords.currentPassword ? "eye slash" : "eye",
                onClick: () => togglePasswordVisibility("currentPassword"),
                type: "button",
                title: showPasswords.currentPassword ? "Ocultar" : "Mostrar",
              }}
            />
            {formik.touched.currentPassword &&
              formik.errors.currentPassword && (
                <Label basic color="red" pointing>
                  {formik.errors.currentPassword}
                </Label>
              )}
          </FormField>

          <FormField>
            <label>Nueva contraseña</label>
            <Input
              icon="lock"
              iconPosition="left"
              placeholder="Mínimo 8 caracteres"
              type={showPasswords.newPassword ? "text" : "password"}
              name="newPassword"
              value={formik.values.newPassword}
              onChange={formik.handleChange}
              error={
                formik.touched.newPassword && formik.errors.newPassword
                  ? formik.errors.newPassword
                  : null
              }
              action={{
                icon: showPasswords.newPassword ? "eye slash" : "eye",
                onClick: () => togglePasswordVisibility("newPassword"),
                type: "button",
                title: showPasswords.newPassword ? "Ocultar" : "Mostrar",
              }}
            />
            {formik.touched.newPassword && formik.errors.newPassword && (
              <Label basic color="red" pointing>
                {formik.errors.newPassword}
              </Label>
            )}
          </FormField>

          <FormField>
            <label>Confirmar nueva contraseña</label>
            <Input
              icon="lock"
              iconPosition="left"
              placeholder="Repite tu nueva contraseña"
              type={showPasswords.confirmPassword ? "text" : "password"}
              name="confirmPassword"
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              error={
                formik.touched.confirmPassword && formik.errors.confirmPassword
                  ? formik.errors.confirmPassword
                  : null
              }
              action={{
                icon: showPasswords.confirmPassword ? "eye slash" : "eye",
                onClick: () => togglePasswordVisibility("confirmPassword"),
                type: "button",
                title: showPasswords.confirmPassword ? "Ocultar" : "Mostrar",
              }}
            />
            {formik.touched.confirmPassword &&
              formik.errors.confirmPassword && (
                <Label basic color="red" pointing>
                  {formik.errors.confirmPassword}
                </Label>
              )}
          </FormField>

          <div className="security-tab__password-actions">
            <Button
              type="submit"
              color="blue"
              disabled={loading}
              loading={loading}
            >
              <Icon name="save" /> Actualizar contraseña
            </Button>
          </div>
        </Form>
      </div>
    </Segment>
  );
}
